import { render, staticRenderFns } from "./DoubleNumberFrameMapDuration.vue?vue&type=template&id=ed2203f0&"
import script from "./DoubleNumberFrameMapDuration.vue?vue&type=script&lang=js&"
export * from "./DoubleNumberFrameMapDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports